import { log } from 'dcmjs';
export const cs3dLog = getRootLogger('cs3d');
export const metadataLog = cs3dLog.getLogger('metadata');
export const coreLog = cs3dLog.getLogger('core');
export const toolsLog = cs3dLog.getLogger('tools');
export const adaptersLog = cs3dLog.getLogger('adapters');
export const loaderLog = cs3dLog.getLogger('dicomImageLoader');
export const niftiVolumeLoaderLog = cs3dLog.getLogger('niftiVolumeLoader');
export const polySegLog = cs3dLog.getLogger('polymorphicSegmentation');
export const labelmapInterpolationLog = cs3dLog.getLogger('labelmapInterpolation');
export const aiLog = cs3dLog.getLogger('ai');
export const examplesLog = cs3dLog.getLogger('examples');
export const workerLog = cs3dLog.getLogger('worker');
export const dicomConsistencyLog = log.getLogger('consistency.dicom');
export const imageConsistencyLog = log.getLogger('consistency.image');
export function getRootLogger(name) {
    const logger = log.getLogger(name);
    logger.getLogger = (...names) => getRootLogger(`${name}.${names.join('.')}`);
    return logger;
}
export function getLogger(...name) {
    return getRootLogger(name.join('.'));
}
export { log };
